var _defs, _title, _rect, _path, _path2, _path3, _line, _line2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDietScale = function SvgDietScale(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "diet-scale")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 3,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.293,7.835a.748.748,0,0,0,.671.415h8.072a.748.748,0,0,0,.671-.415l.96-1.918A.751.751,0,0,0,17.305,4.9,12.831,12.831,0,0,0,6.7,4.9a.751.751,0,0,0-.362,1.019Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,13.125c0-1.036-1.175-1.875-2.625-1.875s-2.625.839-2.625,1.875v5.25a1.875,1.875,0,0,0,3.75,0v-.336a7.416,7.416,0,0,1,1.29-4.179h0A1.423,1.423,0,0,0,10.5,13.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.5,13.125c0-1.036,1.175-1.875,2.625-1.875s2.625.839,2.625,1.875v5.25a1.875,1.875,0,0,1-3.75,0v-.336a7.416,7.416,0,0,0-1.29-4.179h0A1.423,1.423,0,0,1,13.5,13.125Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.75,
    y1: 3.954,
    x2: 9.75,
    y2: 5.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.25,
    y1: 3.954,
    x2: 14.25,
    y2: 5.25
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDietScale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diet-scale.e3a5d996.svg";
export { ForwardRef as ReactComponent };